import { HttpClient } from "../../services/api/httpclient.service";

export class SelfTestService extends HttpClient {
  constructor() {
    super();
  }

  public async getSelfTestLevels() {
    try {
      const response = await this.get(`/self_test/get_self_test_levels`);
      return response;
    } catch (error) {
      console.error("Error fetching self-test levels:", error);
      return [];
    }
  }

  public async getSelfTestTopics(level_id: string) {
    try {  
      const response = await this.get(`/self_test/get_self_test_topics?level_id=${level_id}`);
      return response;
    } catch (error) {
      console.error("Error fetching topics for level:", error);
      return { topics: [] };
    }
  }

  public async get_self_test_exercise_ids(payload: { topic_id: number; level_id: number }) {
    try {
      return await this.post(`/self_test/get_self_test_exercise_ids`, payload);
    } catch (error) {
      console.error("Error fetching self-test exercise ids:", error);
      throw error;
    }
  }

  public async getExercise_test_answers(exercise_id: number) {
    try {
      const response = await this.post(`/self_test/get_exercise_test_answers`, {
        exercise_id,
      });
      return response;
    } catch (error) {
      console.error("Error fetching exercise test answers:", error);
      return null;
    }
  }

  public async get_user_test_exercise_summary(payload: { user_id: number; test_id: number }) {
    try {
      const response = await this.post(`/self_test/get_user_test_exercise_summary`, payload);
      return response;
    } catch (error) {
      console.error("Error fetching exercise test answers:", error);
      return null;
    }
  }

  public async upsert_user_self_test_answers(payload: any[]) {
    try {
      const response = await this.post(`/self_test/upsert_user_self_test_answers`, payload);
      return response;
    } catch (error) {
      console.error("Error fetching exercise test answers:", error);
      return null;
    }
  }
}
